// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"s2-z"};